import React, { Component } from 'react';
import '../../styles/css/ProjectCards/DetailCard.css';
import SecirityIcon from '@material-ui/icons/Security';
import StarRateIcon from '@material-ui/icons/StarRate';
import StarRatingComponent from 'react-star-rating-component';

const token = localStorage.getItem('token');
const userRole = localStorage.getItem('userRole');

class DetailCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {

    const { details } = this.props;

    return (
      <div className="detailCardRoot">
        <div className="detailCardMain">
          <div className="detailCardTitle">
            {
              token && token.length > 0 ?
                (userRole === 'Title Company Admin' || userRole === 'Title Company User') ?
                  <div>
                    <div className="nameMain">
                      <span>{details.Company_name}</span>
                      <SecirityIcon />
                    </div>
                    <div>
                      <StarRatingComponent
                        name="rate1"
                        starCount={5}
                        value={Math.round(details.Company_rating, 10)}
                        starColor={"#9cd5f1"}
                        emptyStarColor={"#b1b1b1"}
                        renderStarIcon={() => <StarRateIcon style={{ width: '20px' }} />}
                        editing={false}
                      />
                    </div>
                  </div>
                  :
                  userRole === 'Surveyor' ?
                    <div>
                      <div className="nameMain">
                        <span>{details.Survey_name}</span>
                        <SecirityIcon />
                      </div>
                      <div>
                        <StarRatingComponent
                          name="rate1"
                          starCount={5}
                          value={Math.round(details.Survey_rating, 10)}
                          starColor={"#9cd5f1"}
                          emptyStarColor={"#b1b1b1"}
                          renderStarIcon={() => <StarRateIcon style={{ width: '20px' }} />}
                          editing={false}
                        />
                      </div>
                    </div>
                    :
                    null
                : null
            }
          </div>
          <div className="detailCardDetails">
            {
              token && token.length > 0 ?
                (userRole === 'Title Company Admin' || userRole === 'Title Company User') ?
                  <div>
                    <hr />
                    <div className="cardDetail">
                      <span>Created</span>
                      <span className="rightAlign">{details.created}</span>
                    </div>
                    <div className="cardDetail">
                      <span>Posted</span>
                      <span className="rightAlign">{details.posted}</span>
                    </div>
                    <div className="cardDetail">
                      <span>Expired</span>
                      <span className="rightAlign">{details.expired}</span>
                    </div>
                    <div className="cardDetail">
                      <span>In progress</span>
                      <span className="rightAlign">{details.inprogress}</span>
                    </div>
                    <div className="cardDetail">
                      <span>Verify</span>
                      <span className="rightAlign">{details.verify}</span>
                    </div>
                    <div className="cardDetail">
                      <span>Completed</span>
                      <span className="rightAlign">{details.completed}</span>
                    </div>
                  </div>
                  :
                  userRole === 'Surveyor' ?
                    <div>
                      <div className="cardDetail">
                        <span>My jobs</span>
                        <span className="rightAlign">{details.my_jobs}</span>
                      </div>
                      <hr />
                      <div className="cardDetail">
                        <span>In progress</span>
                        <span className="rightAlign">{details.inprogress}</span>
                      </div>
                      <div className="cardDetail">
                        <span>Verify</span>
                        <span className="rightAlign">{details.verify}</span>
                      </div>
                      <div className="cardDetail">
                        <span>Completed</span>
                        <span className="rightAlign">{details.completed}</span>
                      </div>
                    </div>
                    :
                    null
                :
                <div>
                  <div className="cardDetail">
                    <span>Available jobs</span>
                    <span className="rightAlign">{details.avaialable}</span>
                  </div>
                  <div className="cardDetail">
                    <span>Ending soon</span>
                    <span className="rightAlign">{details.ending_soon}</span>
                  </div>
                  <hr />
                  <div className="cardDetail">
                    <span>Potential earnings</span>
                    <span className="rightAlign">$ {details.potential_earnings} USD</span>
                  </div>
                </div>
            }
          </div>
        </div>
      </div>
    )
  }
}

export default DetailCard;


// WEBPACK FOOTER //
// ./src/components/ProjectCards/DetailCard.js